<template>
  <div class="about-me-container">
    <ContentRepeater :data="data" />
    <AboutMeVideo1 />
    <AboutMeQuote />
    <AboutMeClients />
    <AboutMeCollage1 :hide="hide1" />
    <AboutMeText1 />
    <AboutMeVideo2 @hide="hide1 = $event" :hide="hide2" />
    <AboutMeImage1 @hide="hide2 = $event" />
    <AboutMeText2 />
    <AboutMeImage2 />
    <AboutMeCollage2 />
    <AboutMeText3 />
    <AboutMeCollage3 />
    <AboutMeText4 />
    <AboutMeImage3 />
    <AboutMeText5 />
    <AboutMeImage4 />
    <AboutMeCollage4 />
    <AboutMeText6 />
    <AboutMeImage5 />
    <AboutMeContact />
  </div>
</template>

<script>
import ContentRepeater from './ContentRepeater.vue'
import AboutMeVideo1 from './about-me/AboutMeVideo1.vue'
import AboutMeVideo2 from './about-me/AboutMeVideo2.vue'
import AboutMeCollage1 from './about-me/AboutMeCollage1.vue'
import AboutMeCollage2 from './about-me/AboutMeCollage2.vue'
import AboutMeCollage3 from './about-me/AboutMeCollage3.vue'
import AboutMeCollage4 from './about-me/AboutMeCollage4.vue'
import AboutMeImage1 from './about-me/AboutMeImage1.vue'
import AboutMeImage2 from './about-me/AboutMeImage2.vue'
import AboutMeImage3 from './about-me/AboutMeImage3.vue'
import AboutMeImage4 from './about-me/AboutMeImage4.vue'
import AboutMeImage5 from './about-me/AboutMeImage5.vue'
import AboutMeQuote from './about-me/AboutMeQuote.vue'
import AboutMeText1 from './about-me/AboutMeText1.vue'
import AboutMeText2 from './about-me/AboutMeText2.vue'
import AboutMeText3 from './about-me/AboutMeText3.vue'
import AboutMeText4 from './about-me/AboutMeText4.vue'
import AboutMeText5 from './about-me/AboutMeText5.vue'
import AboutMeText6 from './about-me/AboutMeText6.vue'
import AboutMeClients from './about-me/AboutMeClients.vue'
import AboutMeContact from './about-me/AboutMeContact.vue'

export default {
  components: {
    ContentRepeater,
    AboutMeVideo1,
    AboutMeVideo2,
    AboutMeCollage1,
    AboutMeCollage2,
    AboutMeCollage3,
    AboutMeCollage4,
    AboutMeImage1,
    AboutMeImage2,
    AboutMeImage3,
    AboutMeImage4,
    AboutMeImage5,
    AboutMeQuote,
    AboutMeText1,
    AboutMeText2,
    AboutMeText3,
    AboutMeText4,
    AboutMeText5,
    AboutMeText6,
    AboutMeClients,
    AboutMeContact,
  },
  props: ['data'],
  data() {
    return {
      hide1: false,
      hide2: false,
    }
  },
  methods: {
    onLinkClick(link) {
      this.$nextTick(() => {
        let el = document.getElementById(link)
        el.scrollIntoView()
        window.scrollBy(0, -100)
      })
    },
  },
  created() {
    if (location.hash.length > 0) {
      this.onLinkClick(location.hash.substr(1))
    }
    this.$root.$on('linkClick', this.onLinkClick)
  },
  beforeDestroy() {
    this.$root.$off('linkClick', this.onLinkClick)
  },
}
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/AboutMe.vue